var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.componentClass, style: _vm.componentStyle },
    [
      _vm.shouldShowSaleTag || _vm.isPlusOnSale
        ? _c("owa-tag", {
            attrs: {
              theme: "yellow",
              label: "On Sale!",
              position: "top",
              size: "size-sm",
            },
          })
        : _vm.isExpiredActivePlan && !_vm.isInModalContext
        ? _c("owa-tag", {
            attrs: {
              theme: "gray inverted",
              label: "Your Expired Plan",
              position: "top",
              size: "size-sm",
            },
          })
        : _vm.isCurrentPlan && !_vm.isInModalContext
        ? _c("owa-tag", {
            attrs: {
              theme: "blue",
              label:
                _vm.useProCardForLegacyPlan && _vm.currentSubName
                  ? `Your Plan · ${_vm.currentSubName}`
                  : "Your Plan",
              position: "top",
              size: "size-sm",
            },
          })
        : _vm.plan.mostPopular &&
          !_vm.shouldShowSaleTag &&
          !_vm.isDowngrade &&
          !(_vm.isInModalContext && _vm.isSinglePlanModal)
        ? _c("owa-tag", {
            attrs: {
              theme: "yellow",
              label: "Most Popular",
              position: "top",
              size: "size-sm",
            },
          })
        : _vm.plan.sku === "FA-STANDARD-PLUS" &&
          !_vm.shouldShowSaleTag &&
          _vm.shouldShowBestValueTag &&
          !_vm.isDowngrade &&
          !_vm.hasActivePaidSubscription &&
          _vm.isInModalContext
        ? _c("owa-tag", {
            attrs: {
              theme: "teal",
              label: "Best Value",
              position: "top",
              size: "size-sm",
            },
          })
        : !_vm.plan.proDownloadEnabled &&
          (!_vm.isInModalContext || _vm.isSinglePlanModal)
        ? _c("owa-tag", {
            attrs: {
              theme: "gravy",
              label: "Online Only",
              position: "top",
              size: "size-sm",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("h2", { staticClass: "h1 margin-bottom-2xs" }, [
        _c(
          "span",
          { style: `color: var(--fa-${_vm.planColor});` },
          [
            _c("font-awesome-icon", {
              staticClass: "decorative fa-width-auto",
              attrs: { icon: _vm.$v7[_vm.planIconStyle][_vm.icon], size: "lg" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass:
              "size-md tablet:size-sm laptop:size-md tablet:display-block laptop:display-inline",
          },
          [
            _vm.shortName
              ? _c("span", [_vm._v(_vm._s(_vm.shortName))])
              : _c("span", [_vm._v(_vm._s(_vm.activePlan.name))]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            "flex-grow": "1",
            "flex-shrink": "0",
            "flex-basis": "auto",
          },
        },
        [
          _vm.isInModalContext
            ? [
                _c("h3", { staticClass: "sr-only" }, [
                  _vm._v("This Plan Includes…"),
                ]),
                _vm._v(" "),
                _vm.planDescriptionModal
                  ? _c(
                      "p",
                      {
                        staticClass: "margin-bottom-md size-lg",
                        staticStyle: { color: "var(--fa-md-gravy)" },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.planDescriptionModal) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "size-lg fa-ul margin-y-0 margin-left-xl" },
                  [
                    _c(
                      "li",
                      { staticClass: "b" },
                      [
                        _c(
                          "span",
                          { staticClass: "fa-li" },
                          [
                            _c("font-awesome-icon", {
                              attrs: {
                                icon: _vm.$v7.solid.faCheck,
                                size: "sm",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.modalContextSlug.includes("custom_icon") ||
                        _vm.modalContextSlug.includes("using_the_icon_wizard")
                          ? [
                              _vm.plan.customIcons === -1
                                ? [
                                    _vm._v(
                                      "\n              Unlimited\n            "
                                    ),
                                  ]
                                : [
                                    _vm._v(
                                      "\n              Includes " +
                                        _vm._s(_vm.plan.customIcons) +
                                        "\n            "
                                    ),
                                  ],
                              _vm._v("\n            custom icons\n          "),
                            ]
                          : _vm.modalContextSlug.includes("download")
                          ? [
                              _vm.planHasProPlusIcons
                                ? [
                                    _vm._v(
                                      "Download Pro & Pro+ SVGs, fonts, and assets"
                                    ),
                                  ]
                                : [
                                    _vm._v(
                                      "Download Pro SVGs, fonts, and assets"
                                    ),
                                  ],
                            ]
                          : _vm.modalContextSlug.includes("using_this_icon")
                          ? [
                              _vm.planHasProPlusIcons
                                ? [_vm._v("Use Pro & Pro+ icons in projects")]
                                : [_vm._v("Use Pro icons in projects")],
                            ]
                          : _vm.modalContextSlug.includes("pro_icon")
                          ? [
                              _vm._v(
                                "\n            Unlock Pro Icons in Kits\n          "
                              ),
                            ]
                          : _vm.modalContextSlug.includes(
                              "removing_advertisements"
                            )
                          ? [
                              _vm._v(
                                "\n            Ad-free experience\n          "
                              ),
                            ]
                          : _vm.modalContextSlug.includes("service")
                          ? [
                              _vm._v(
                                "\n            Unlock Additional Services\n          "
                              ),
                            ]
                          : [
                              _vm._v(
                                "\n            Unlock this feature\n          "
                              ),
                            ],
                      ],
                      2
                    ),
                  ]
                ),
              ]
            : [
                _c("h3", { staticClass: "sr-only" }, [
                  _vm._v("About This Plan"),
                ]),
                _vm._v(" "),
                _vm.planDescriptionPrimary
                  ? _c("p", { staticClass: "margin-bottom-md size-lg" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.planDescriptionPrimary) +
                          "\n      "
                      ),
                    ])
                  : _c("p", { staticClass: "margin-bottom-0" }, [
                      _vm._v(
                        "\n        " + _vm._s(_vm.plan.description) + "\n      "
                      ),
                    ]),
                _vm._v(" "),
                _vm.planDescriptionSecondary
                  ? _c("p", { staticStyle: { color: "var(--fa-md-gravy)" } }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.planDescriptionSecondary) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.isShowingDiscount
            ? [
                _c(
                  "div",
                  {
                    staticClass: "row align-middle align-center margin-y-sm",
                    staticStyle: {
                      gap: "var(--spacing-xs)",
                      "--grid-gutter-x-width": "0",
                      "--padding-left": "0",
                      "--padding-right": "0",
                    },
                  },
                  [
                    _vm.currentDollars !== _vm.planPrice
                      ? _c(
                          "div",
                          {
                            staticClass: "strong text-center",
                            staticStyle: { color: "var(--fa-gravy)" },
                          },
                          [
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Regular price:"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "size-4xl tablet:size-3xl laptop:size-4xl",
                              },
                              [
                                _c("s", [
                                  _vm._v(_vm._s(_vm.planPrice)),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("/year"),
                                  ]),
                                ]),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "strong" }, [
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Current price:"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "display-flex align-start align-center",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "size-4xl tablet:size-3xl laptop:size-4xl",
                            },
                            [_vm._v(_vm._s(_vm.currentDollars))]
                          ),
                          _vm._v(" "),
                          _vm.currentCents
                            ? _c(
                                "span",
                                { staticClass: "size-lg padding-top-2xs" },
                                [_vm._v("." + _vm._s(_vm.currentCents))]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v(_vm._s(_vm.priceDurationLabel)),
                        _vm.discountDuration === "once"
                          ? _c("span", [
                              _vm._v(
                                ", then " + _vm._s(_vm.planPrice) + "/year"
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]
                ),
              ]
            : _c("div", { staticClass: "text-center" }, [
                _c("p", { staticClass: "size-4xl strong margin-y-4xs" }, [
                  _vm._v("\n        " + _vm._s(_vm.currentDollars)),
                  _vm.currentCents
                    ? _c("span", [_vm._v("." + _vm._s(_vm.currentCents))])
                    : _vm._e(),
                ]),
              ]),
          _vm._v(" "),
          _vm.isShowingCheckbox && !_vm.isInModalContext
            ? [
                _c("input", {
                  staticClass: "with-icon",
                  attrs: { id: `plus-addon-${_vm.plan.sku}`, type: "checkbox" },
                  domProps: { checked: _vm.plusChecked },
                  on: {
                    change: function ($event) {
                      _vm.plusChecked = $event.target.checked
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass:
                      "display-flex flex-items-center gap-sm padding-sm margin-top-xl margin-bottom-xl",
                    style: {
                      "--label-display": "flex",
                      width: "100%",
                      background: _vm.plusChecked
                        ? "var(--fa-lt-gravy)"
                        : "var(--white)",
                      border: "2px solid var(--fa-lt-gravy)",
                      borderRadius: "var(--border-radius-sm)",
                      cursor: "pointer",
                      "font-weight": "var(--font-weight-normal)",
                    },
                    attrs: { for: `plus-addon-${_vm.plan.sku}` },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "position-relative",
                        staticStyle: {
                          "flex-shrink": "0",
                          color: "var(--fa-navy)",
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "unchecked-icon",
                          attrs: { icon: _vm.$v7.regular.faSquare, size: "lg" },
                        }),
                        _vm._v(" "),
                        _c("font-awesome-icon", {
                          staticClass: "hover-icon",
                          attrs: { icon: _vm.$v7.regular.faSquare, size: "lg" },
                        }),
                        _vm._v(" "),
                        _c("font-awesome-icon", {
                          staticClass: "checked-icon",
                          attrs: {
                            icon: _vm.$v7.solid.faSquareCheck,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "size-md padding-left-xs" },
                      [
                        _vm.plusChecked
                          ? [_vm._v("Added Pro+ Icons")]
                          : [_vm._v("Add Pro+ Icons")],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    !_vm.plusChecked && _vm.checkboxHelperText
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "size-sm muted margin-left-auto tablet:display-none laptop:display-inline",
                          },
                          [_vm._v(_vm._s(_vm.checkboxHelperText))]
                        )
                      : _vm._e(),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isCurrentPlan && !_vm.isExpiredPlan
            ? _c(
                "span",
                {
                  class: `button flat size-lg block margin-y-0 ${_vm.planColor} inverted`,
                  staticStyle: { "pointer-events": "none" },
                },
                [_vm._v("Your Plan!")]
              )
            : _vm.isDowngrade
            ? _c(
                "site-link",
                {
                  class: `button flat with-border size-lg block margin-y-0`,
                  attrs: { to: _vm.planLinkArguments(_vm.plan) },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.trackThen($event, _vm.isInModalContext)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      Downgrade to " + _vm._s(_vm.plan.name) + "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          (!_vm.isCurrentPlan || _vm.isExpiredPlan) && !_vm.isDowngrade
            ? _c(
                "site-link",
                {
                  class: `button size-lg block margin-bottom-0 ${_vm.planColor}`,
                  attrs: { to: _vm.planLinkArguments(_vm.activePlan) },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.trackThen($event, _vm.isInModalContext)
                    },
                  },
                },
                [
                  _vm.hasActivePaidSubscription
                    ? [_vm._v("Upgrade to " + _vm._s(_vm.activePlan.name))]
                    : [_vm._v("Get " + _vm._s(_vm.activePlan.name))],
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "text-center",
              staticStyle: {
                color: "var(--fa-md-gravy)",
                "padding-top": "var(--spacing-2xl)",
                "margin-bottom": "calc(-1 * var(--spacing-md))",
              },
              attrs: {
                "aria-label": _vm.priceDurationDescription,
                "data-balloon-pos": "down",
                "data-balloon-length": "fit",
              },
            },
            [
              _c("font-awesome-icon", {
                staticClass: "decorative margin-right-2xs",
                attrs: { icon: _vm.$v7.solid.faCalendarDays, size: "lg" },
              }),
              _vm._v("\n      " + _vm._s(_vm.priceDurationLabel) + "\n    "),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }